import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import SydLabel from '../../../commonDesign/SydLabel'
import SydInput from '../../../commonDesign/SydInput'
import { useEntityGraphContext } from '../Wrapper/EntityGraphProvider'
import Switch from '../../../molecules/Switch'

export const EdgeSettings = ({ edgeId }) => {
  const { state: { data }, dispatch } = useEntityGraphContext()

  const edge = useMemo(() => data?.edges?.find(edge => edge.id === edgeId), [data, edgeId])
  const style = useMemo(() => edge?.data?.style || {}, [edge?.data?.style])
  const labelStyle = useMemo(() => edge?.data?.labelStyle || {}, [edge?.data?.labelStyle])

  const updateEdge = (path, value) => {
    dispatch({
      type: 'UPDATE_EDGE',
      payload: { edgeId, path, value }
    })
  }

  return (
    <div className='flex flex-col gap-2 mt-4'>
      <SydLabel label='Line Color'>
        <SydInput
          size='sm'
          type='color'
          onChange={(e) => updateEdge(['data', 'style', 'stroke'], e.target.value)}
          value={style.fill ?? '#000000'}
        />
      </SydLabel>

      <div className='flex gap-sm'>
        <SydLabel label='Dashed Line'>
          <Switch
            size='sm'
            type='color'
            onChange={(e) => updateEdge(['data', 'style', 'strokeDasharray'], style.strokeDasharray ? null : '5,5')}
            checked={!!style.strokeDasharray}
          />
        </SydLabel>
        {style.strokeDasharray && (
          <SydLabel label='Animate Line'>
            <Switch
              size='sm'
              type='color'
              onChange={(e) => updateEdge(['animated'], !edge.animated)}
              checked={!!edge.animated}
            />
          </SydLabel>
        )}
      </div>

      <SydLabel label='Label'>
        <SydInput
          size='sm'
          placeholder='Line Label'
          onChange={(e) => updateEdge(['data', 'label'], e.target.value)}
          value={edge?.data?.label || ''}
        />
      </SydLabel>
      {!!edge?.data?.label?.length && (
        <>
          <SydLabel label='Label Color'>
            <SydInput
              size='sm'
              type='color'
              onChange={(e) => updateEdge(['data', 'labelStyle', 'color'], e.target.value)}
              value={style.fill ?? '#000000'}
            />
          </SydLabel>

          <SydLabel label='Label Font Size'>
            <SydInput
              size='sm'
              type='number'
              onChange={(e) => updateEdge(['data', 'labelStyle', 'fontSize'], e.target.value + 'px')}
              value={parseInt(labelStyle.fontSize ?? 12, 0)}
              className='mb-2'
            />
          </SydLabel>
        </>
      )}
    </div>
  )
}

EdgeSettings.propTypes = {
  edgeId: PropTypes.string.isRequired
}
